import { render } from "./loading-animation.vue?vue&type=template&id=5daa362d&ts=true"
import script from "./loading-animation.ts?vue&type=script&lang=ts&external"
export * from "./loading-animation.ts?vue&type=script&lang=ts&external"

import "./loading-animation.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__